import { estimateConstants } from '../constants/actionTypes'

const initialState = {
  estimates: [],
  isFetching: false,
}

export function estimates(state = initialState, action) {
  switch (action.type) {
    case estimateConstants.FETCH_ESTIMATES_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case estimateConstants.FETCH_ESTIMATES_SUCCESS:
      if (action.estimates !== null && action.estimates !== undefined) {
        action.estimates = action.estimates.sort(function (x, y) {
          // true values first
          return x.isValid === y.isValid ? 0 : x.isValid ? -1 : 1
          //return !(x.isValid - y.isValid)
          // false values first
          // return (x === y)? 0 : x? 1 : -1;
        })
      }
      return {
        estimates: action.estimates,
        tradeIn: action.tradeIn,
        isFetching: false,
      }
    case estimateConstants.FETCH_ESTIMATES_ERROR:
      return {
        estimates: [],
        isFetching: false,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
